import styled from 'styled-components';

const Icon = styled.div`
  width: 16px;
  height: 8px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid var(--neutral-6);
`;

export { Icon };
